export const module = {
  info: {
    name: 'voip-mrt-rate-division-menu',
    caption: 'MRT Division Menu',
    viewGroup: 'mrt-modules'
  },
  vuexModules: [],
  mainRoute: '/cpanel',
  // noRoutes: true,
  sideMenu: {
    topSeparator: false,
    caption: 'MRT Division',
    icon: 'el-icon-folder',
    routeName: 'module->voip-mrt-rate-division-menu->create',
    children: [
      {
        caption: 'Create MRT Division',
        icon: 'el-icon-plus',
        routeName: 'module->voip-mrt-rate-division->create'
      },
      {
        caption: 'List MRT Divisions',
        icon: 'el-icon-more-outline',
        routeName: 'module->voip-mrt-rate-division->list->page',
        routeParams: { listPage: 1}
      }
    ]
  }
}

export default module
